/**
 * Show feedback for the user inside input boxes of form.
 *
 * @param type
 * @param result
 */
function mas_form_call_message_input(type = '', result = '') {
	result.removeClass( 'forms__result--success' )
		.removeClass( 'forms__result--error' )
		.removeClass( 'forms__result--info' );
	let iconType;

	switch (type) {
		case 'success':
			iconType = 'icon-general-success';
			result.addClass( 'forms__result--success' );
			break;
		case 'error':
			iconType = 'icon-general-fail';
			result.addClass( 'forms__result--error' );
			break;
		default:
			iconType = 'icon-general-info-black';
			result.addClass( 'forms__result--info' );
			break;
	}
	const icon = jQuery( '<i>', { class: iconType } );
	result.empty().append( icon );
}

/**
 * Clears div classes and empties them.
 */
function mas_form_call_message_general_clean() {
	const result = jQuery( '.forms__common-result' );
	result.removeClass( 'forms__common-result--success' )
		.removeClass( 'forms__common-result--error' )
		.removeClass( 'forms__common-result--info' )
		.empty();
}

/**
 * Show feedback of general errors for the user in a text box.
 *
 * @param message
 * @param type
 */
function mas_form_call_message_general(message = '', type = '') {
	const result    = jQuery( '#masCallResult' );
	const paragraph = jQuery( '<p>', { text: message } );

	/**
	 * Builder result section
	 */
	let iconType;

	switch (type) {
		case 'success':
			iconType = 'icon-general-success';
			result.addClass( 'forms__common-result--success' );
			paragraph.addClass( 'js-form-success' );
			break;
		case 'error':
			iconType = 'icon-general-fail';
			result.addClass( 'forms__common-result--error' );
			paragraph.addClass( 'js-form-error' );
			break;
		default:
			iconType = 'icon-general-info-black';
			result.addClass( 'forms__common-result--info' );
			paragraph.addClass( 'js-form-info' );
			break;
	}
	const icon = jQuery( '<i>', { class: iconType } );

	mas_form_call_message_general_clean();
	result.append( icon, paragraph );
}

/**
 * Disable submit form button.
 */
function mas_form_call_submit_disabled() {
	jQuery( '#masCallSubmit' ).prop( "disabled", true );
}

/**
 * Enable submit form button.
 */
function mas_form_call_submit_enabled() {
	jQuery( '#masCallSubmit' ).prop( "disabled", false );
}

/**
 * Reset form fields and feedback icon.
 */
function mas_form_call_reset() {
	jQuery( '#masCall' ).trigger( "reset" );
	jQuery( '.forms__result' ).empty();
}

/**
 * Send form to custom customer ajax action.
 *
 * @param nif
 * @param company
 * @param name
 * @param phone
 * @param postal
 * @param email
 * @param employee
 * @param origin
 * @param time
 * @param nonce
 * @param customer
 * @param token
 * @param checkbox
 */
function mas_form_call_send(
	nif,
	company,
	name,
	phone,
	postal,
	email,
	employee,
	origin,
	time,
	nonce,
	customer,
	token,
	checkbox
) {
	let myRequestURL = '/wp-admin/admin-ajax.php?timestamp=' + new Date().getTime();
	jQuery.ajax(
		{
			type: "POST",
			url: myRequestURL,
			data: {
				'action': 'mas_form_call',
				'data': {
					'nif': nif.val(),
					'company': company.val(),
					'name': name.val(),
					'phone': phone.val(),
					'postal': postal.val(),
					'email': email.val(),
					'employee': employee.val(),
					'origin': origin.val(),
					'time': time.val(),
					'nonce': nonce.val(),
					'customer': customer.val(),
					'token': token,
					'checkbox': checkbox.is( ":checked" )
				}
			},
			dataType: 'json',
			crossDomain: true,
			cache: false,
			beforeSend: function () {
				mas_form_call_submit_disabled();
				mas_form_call_message_general(
					'Estamos procesando su solicitud.' +
					' Por favor, espere. Puede tardar varios segundos.'
				);
			},
			success: function (data, textStatus, jqXHR) {
				mas_form_call_submit_enabled();
				mas_form_call_reset();
				if (200 !== jqXHR.status) {
					return;
				}
				mas_form_call_message_general( data.message, 'success' );
			},
			error: function (jqXHR) {
				mas_form_call_submit_enabled();
				mas_form_call_reset();
				const response = JSON.parse( jqXHR.responseText );
				mas_form_call_message_general( response.message, 'error' );
			}
		}
	);
}

/**
 * Validate specific fields before sending.
 *
 * @param nif
 * @param company
 * @param name
 * @param phone
 * @param postal
 * @param email
 * @param employee
 * @param origin
 *
 * @returns {boolean}
 */
function mas_form_call_validate(
	nif,
	company,
	name,
	phone,
	postal,
	email,
	employee,
	origin
) {
	let isError = false;

	/**
	 * NIF field validation
	 */
	const domResultNif = jQuery( '.forms__result[data-field="' + nif.attr( "id" ) + '"]' );
	if (9 !== nif.val().length) {
		mas_form_call_message_input( 'error', domResultNif );
		isError = true;
	} else {
		mas_form_call_message_input( 'success', domResultNif );
	}

	/**
	 * COMPANY field validation
	 */
	const domResultCompany = jQuery( '.forms__result[data-field="' + company.attr( "id" ) + '"]' );
	if ( 0 === company.val().length ) {
		mas_form_call_message_input( 'error', domResultCompany );
		isError = true;
	} else {
		mas_form_call_message_input( 'success', domResultCompany );
	}

	/**
	 * NAME field validation
	 */
	const domResultName = jQuery( '.forms__result[data-field="' + name.attr( "id" ) + '"]' );
	if (0 === name.val().length) {
		mas_form_call_message_input( 'error', domResultName );
		isError = true;
	} else {
		mas_form_call_message_input( 'success', domResultName );
	}

	/**
	 * PHONE field validation
	 */
	const domResultPhone = jQuery( '.forms__result[data-field="' + phone.attr( "id" ) + '"]' );
	if ( ! (/^\d{9}$/.test( phone.val() ))) {
		mas_form_call_message_input( 'error', domResultPhone );
		isError = true;
	} else {
		mas_form_call_message_input( 'success', domResultPhone );
	}

	/**
	 * POSTAL field validation
	 */
	const domResultPostal = jQuery( '.forms__result[data-field="' + postal.attr( "id" ) + '"]' );
	if ( ! (/^(?:0?[1-9]|[1-4]\d|5[0-2])\d{3}$/.test( postal.val() ))) {
		mas_form_call_message_input( 'error', domResultPostal );
		isError = true;
	} else {
		mas_form_call_message_input( 'success', domResultPostal );
	}

	/**
	 * EMAIL field validation
	 */
	const domResultEmail = jQuery( '.forms__result[data-field="' + email.attr( "id" ) + '"]' );
	if ( ! (/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test( email.val() ))) {
		mas_form_call_message_input( 'error', domResultEmail );
		isError = true;
	} else {
		mas_form_call_message_input( 'success', domResultEmail );
	}

	/**
	 * EMPLOYEE number field validation
	 */
	const domResultEmployee = jQuery(
		'.forms__result[data-field="' + employee.attr( "id" ) + '"]'
	);
	if (0 >= employee.val()) {
		mas_form_call_message_input( 'error', domResultEmployee );
		isError = true;
	} else {
		mas_form_call_message_input( 'success', domResultEmployee );
	}

	/**
	 * ORIGIN field validation
	 */
	const domResultOrigin = jQuery('.forms__result[data-field="' + origin.attr("id") + '"]');
	if (origin.val() !== 'web' && origin.val() !== 'campaign') {
		mas_form_call_message_input('error', domResultOrigin);
		isError = true;
	} else {
		mas_form_call_message_input('success', domResultOrigin);
	}


}

/**
 * Validate security fields before sending.
 *
 * @param time
 * @param nonce
 * @param call
 *
 * @returns {boolean}
 */
function mas_form_call_validate_security(time, nonce, call) {
	if (0 === time.val().length) {
		return false;
	}
	if (0 === nonce.val().length) {
		return false;
	}
	if (0 < call.val().length) {
		return false;
	}

	return true;
}

/**
 * Validate checkbox field before sending.
 *
 * @param checkbox
 *
 * @returns {boolean}
 */
function mas_form_call_validate_checkbox(checkbox) {
	if (false === checkbox.is( ":checked" )) {
		return false;
	}

	return true;
}


/**
 * Handle submit custom customer form.
 */
function mas_form_call_initialize() {
	const form = jQuery( '#masCall' );
	form.on(
		'submit',
		function (event){
			event.preventDefault();

			const nif         = jQuery( '#masCallNif' );
			const company     = jQuery( '#masCallCompany' );
			const name        = jQuery( '#masCallName' );
			const phone       = jQuery( '#masCallContactPhone' );
			const postal  	  = jQuery( '#masCallPostal' );
			const email       = jQuery( '#masCallContactEmail' );
			const employee    = jQuery( '#masCallNumberEmployee' );
			const origin      = jQuery( '#masCallOrigin' );
			const time        = jQuery( '#masCallTime' );
			const nonce       = jQuery( '#masCallNonce' );
			const call        = jQuery( '#masCall' );
			const key         = jQuery( '#masFormPublicKey' );
			const checkbox    = jQuery( '#masCallLegalCheckbox' );

			if (false === mas_form_call_validate(
				nif,
				company,
				name,
				phone,
				postal,
				email,
				employee,
				origin
			)) {
				mas_form_call_message_general(
					'¡Ups! Revise alguno de los campos.',
					'error'
				);
				return false;
			}

			if (false === mas_form_call_validate_security(
				time,
				nonce,
				call
			)) {
				mas_form_call_message_general(
					'¡Ups! Algo no ha ido bien. Refresque la página y pruebe de nuevo.',
					'error'
				);
				return false;
			}

			if (false === mas_form_call_validate_checkbox( checkbox )) {
				mas_form_call_message_general(
					'¡Ups! Acepte la casilla de la política de privacidad.',
					'error'
				);
				return false;
			}

			grecaptcha.ready(
				function () {
					grecaptcha.execute( key.val(), { action: 'submit' } ).then(
						function (token) {
							if (0 === token.length) {
								mas_form_call_message_general(
									'¡Ups! Algo no ha ido bien.' +
									' Refresque la página y pruebe de nuevo.',
									'error'
								);
								return false;
							}

							mas_form_call_send(
								nif,
								company,
								name,
								phone,
								postal,
								email,
								employee,
								origin,
								time,
								nonce,
								call,
								token,
								checkbox
							);

							return true;
						}
					);
				}
			);

			return true;
		}
	);
}

(function ($) {
	$( document ).ready(
		function () {
			mas_form_call_initialize();
		}
	);
})( jQuery );
